import React from 'react'

const NotificationIcon = (props) => {
    const stroke = props.stroke || '#18ACDD'
    const height = props.height || '25'
    const width = props.width || '25'
    const customizedStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: '10px',
    }
    return (
        <div style={customizedStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={stroke} stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
        </div>
    )
}

export default NotificationIcon
